//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dealCustomizer from '../../../common/mixins/customizer/dealCustomizer'
import redirectWeb from '../../../common/mixins/redirectWeb'

export default {
  name: 'Deal',
  mixins: [dealCustomizer(), redirectWeb],
  data () {
    return {
      showProductDetails: false
    }
  },
  head () {
    return {
      title: this.$getPageTitle(this.currentItem ? this.$capitalize(this.currentItem.product_type + ' - ' + this.currentItem.name) : 'dealCustomizer')
    }
  }
}
